import {getField, updateField} from 'vuex-map-fields';
import History from '@/commonFunction/baseTableModule'

let history_detail = new History('/ws/base_history/');

const state = {
    ...history_detail.state,
    columns: [
        {text: '', value: 'actions', sortable: false, divider: true, width: 40, brief: true,},
        // {text: 'id', value: 'id', sortable: true, divider: true, width: 80, brief: true,},
        {text: 'Date', value: 'date_only', sortable: true, divider: true, width: 80, brief: true,},
        {text: 'Time', value: 'history_date', sortable: true, divider: true, width: 80, brief: true,},
        // {text: 'User', value: 'history_user__username', sortable: true, divider: true, width: 80, brief: true,},
        // {text: 'history_id', value: 'history_id', sortable: true, divider: true, width: 80, brief: true,},
        // {text: 'history_diff', value: 'history_diff', sortable: true, divider: true, width: 80, brief: true,},
        {text: 'Alive', value: 'alive', sortable: true, divider: true, width: 80, brief: true,},
        {text: 'File', value: 'file__filename', sortable: true, divider: true, width: 80, brief: true,},
        {text: 'Source', value: 'source_type', sortable: false, divider: true, width: 80, brief: true,},
        {text: 'Title', value: 'title', sortable: false, divider: true, brief: true,},
        // {text: 'store_doc', value: 'store_doc', sortable: false, divider: true, width: 80, brief: true,},
        {text: 'Edited by', value: 'edited_by__username', sortable: false, divider: true, width: 80, brief: true,},
        {text: 'Created by', value: 'created_by__username', sortable: false, divider: true, width: 80, brief: true,},
    ],
    options: {
                page: 1,
                itemsPerPage: 20,
                sortBy: ['history_id'],
                sortDesc: [true],
                multiSort: false,
                mustSort: true,
                descending: false,
            },
    month_left: new Date().toISOString().substr(0, 10),
    month_right: new Date().toISOString().substr(0, 10),
};
const getters = {
    ...history_detail.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...history_detail.actions,
};
const mutations = {
    ...history_detail.mutations,
};

export default {
    modules: {
        BaseHistoryFileDetail: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}